import { graphql } from '@graphql/gql';

export const ON_ATTENDEE_HAS_CHANNELS = graphql(`
  subscription ON_ATTENDEE_HAS_CHANNELS($eventId: ID!, $attendeeId: ID!) {
    onAttendeeHasChannelsV2(eventId: $eventId, attendeeId: $attendeeId) {
      status
      eventId
      attendeeId
    }
  }
`);
